import YesIcon from 'assets/images/yes-icon.svg';

import SuccessImage from 'assets/images/create-success.svg';
import CancelRenewalImage from 'assets/images/cancel-renewal-v2.svg';
import CanceSubslImage from 'assets/images/sad-smiley.svg';
import ThumbsupImage from 'assets/images/thumbsup-smiley.svg';

import Logo from 'assets/images/logo.svg';
import Theme from 'theme';

const {
  REACT_APP_GROUP_ID: groupId,
  REACT_APP_AWS_REGION: region,
  REACT_APP_COGNITO_POOL_ID: userPoolId,
  REACT_APP_COGNITO_WEB_CLIENT_ID: userPoolWebClientId,
  REACT_APP_APPPOINTMENT_LINK: bookAppointmentLink
} = process.env;

const config = {
  groupId,
  region,
  userPoolId,
  userPoolWebClientId,
  logo: Logo,
  cptCodesIcon: YesIcon,
  portalName: 'Dental Depot Dental',
  tokenName: 'dentalDepotSubscriberToken',
  globalClass: 'dental-depot-container',
  clientHeader: groupId,
  pricingType: 'standard-pricing',
  headerProps: {
    enable: false,
    floatingHeader: true,
  },
  homeTemplateProps: {
    heroSection: {
      variant: 1,
      heroImage: '/images/home-images/home-banner-img.webp',
      subTitleColor: 'textSecondary',
      verticalAlignImage: 'bottom',
      secondaryButtonProps: {
        to: '/login',
        color: 'primary'
      },
    },
    benefitsSection: {
      variant: 2,
      columns: 4,
      alignTitle: 'left',
      alignCard: 'left',
    },
    subscriptionSection: {
      priority: 'bottom',
      tabVariant: 2,
      titleClasses: 'text-highlight',
      subTitleClasses: 'text-highlight',
      primaryButtonProps: {
        color: 'secondary'
      },
      carouselResponsiveItems: {
        desktop: 3,
      },
    },
    howItWorksSection: {
      variant: 2,
      alignTitle: 'left',
      heroImage: '/images/home-images/how-it-works.webp',
      clipPath: false
    },
    testimonialSection: {
      variant: 2,
      centerMode: true,
      avatarStyle: 'top',
      subtitleVariant: 'body1',
      sectionClass: 'section-container',
      messageType: 'h6',
      carouselResponsiveItem: {
        superLarge: 1,
        large: 1,
      },
    },
    staticHeroSection: {
      enable: true,
      variant: 1,
      subtitleProps: {
        color: 'textSecondary',
      },
      primaryButtonProps: {
        color: 'primary',
      },
    },
  },
  subscriptionSuccess: {
    successImage: SuccessImage,
    enableBookAppointment: false,
    bookAppointmentProps: {
      locationList: [{
        name: "Little Elm",
        link: bookAppointmentLink,
        target: '_blank'
      }],
    },
  },
  checkoutSection: {},
  choosePlanSection: {
    tabVariant: 2,
    cardVariant: 2,
    planCardProps: {
      buttonProps: {
        normalColor: "primary",
        normalVariant: "outlined",
        highlightedColor: "primary",
        highlightedVariant: "contained",
      },
    },
    staticHeroSection: {
      enable: true,
      variant: 1,
      primaryButtonProps: {
        color: 'primary'
      },
    },
  },
  savingsSummary: {},
  faqSection: {},
  dashboardProps: {
    showBenefitsUsage: true,
    cancelRenewal: {
      image: CancelRenewalImage,
    },
    cancelSubscription: {
      image: CanceSubslImage,
    },
    reactivateRenewal: {
      image: ThumbsupImage,
    },
  },
  footer: {
    enable: false,
  },
  loginPage: {
    bannerImage: './images/login.webp',
  },
  theme: Theme
};

export default config;
